/* Roles */
export const GET_ROLE = "GET_ROLE";
export const GET_ROLE_SUCCESS = "GET_ROLE_SUCCESS";
export const GET_ROLE_ERROR = "GET_ROLE_ERROR";

export const GET_ROLES = "GET_ROLES";
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS";
export const GET_ROLES_ERROR = "GET_ROLES_ERROR";

/* Permissions */
export const GET_PERMISSION = "GET_PERMISSION";
export const GET_PERMISSION_SUCCESS = "GET_PERMISSION_SUCCESS";
export const GET_PERMISSION_ERROR = "GET_PERMISSION_ERROR";

export const GET_PERMISSIONS = "GET_PERMISSIONS";
export const GET_PERMISSIONS_SUCCESS = "GET_PERMISSIONS_SUCCESS";
export const GET_PERMISSIONS_ERROR = "GET_PERMISSIONS_ERROR";

/* Role Permissions */
export const GET_ROLEPERMISSION = "GET_ROLEPERMISSION";
export const GET_ROLEPERMISSION_SUCCESS = "GET_ROLEPERMISSION_SUCCESS";
export const GET_ROLEPERMISSION_ERROR = "GET_ROLEPERMISSION_ERROR";

export const GET_ROLEPERMISSIONS = "GET_ROLEPERMISSIONS";
export const GET_ROLEPERMISSIONS_SUCCESS = "GET_ROLEPERMISSIONS_SUCCESS";
export const GET_ROLEPERMISSIONS_ERROR = "GET_ROLEPERMISSIONS_ERROR";
